<template>
  <v-container fluid class="pt-1">
    <v-layout column wrap>
      <customer-image
        class="mb-3"
        :file="value.photo"
        v-model="value.image"
        v-if="value.type == 'bank'"
      />
      <v-text-field
        outline
        multiple
        small-chips
        :label="$t('code')"
        data-vv-name="code"
        v-model="value.code"
        v-validate="'required'"
        :data-vv-as="$t('code')"
        :error-messages="errors.collect('code')"
        v-if="
          value.type == 'expense' ||
          value.type == `income` ||
          value.type == `asset`
        "
      />
      <v-text-field
        outline
        :label="$t('name')"
        data-vv-name="name"
        v-model="value.name"
        v-validate="'required'"
        :data-vv-as="$t('name')"
        :error-messages="errors.collect('name')"
      />
      <v-text-field
        outline
        v-validate="'required'"
        :label="$t('father_name')"
        data-vv-name="father_name"
        v-model="value.father_name"
        v-if="value.type == 'external'"
        :data-vv-as="$t('father_name')"
        :error-messages="errors.collect('father_name')"
      />
      <v-combobox
        outline
        multiple
        small-chips
        :label="$t('phones')"
        v-model="value.phones"
        v-if="
          value.type != 'expense' &&
          value.type != `income` &&
          value.type != `asset`
        "
      />
      <v-textarea
        outline
        auto-grow
        rows="0"
        v-model="value.address"
        :label="$t('description')"
      />
      <v-checkbox
        placeholder
        singleLine
        hide-details
        color="primary"
        class="mb-4 pa-0"
        v-if="value.type == 'asset'"
        :label="$t('current_assets')"
        v-model="value.is_current_asset"
      />
    </v-layout>
    <v-btn color="primary" class="mx-0" @click="save" :loading="loading">{{
      $t("save")
    }}</v-btn>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";

export default {
  props: ["value"],
  data: () => ({
    loading: false,
  }),
  mixins: [customersMixin],
  methods: {
    save() {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.axios.post("customers", this.value).then((res) => {
            this.loading = false;
            this.value.id = res.data.data.id;
            this.$store.commit("showSnackbar", {
              text: this.$t("save_succeed"),
              stateType: "success",
              show: true,
            });
            this.getCustomers();
            this.$emit("saved", res.data.data);
          });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
        }
      });
    },
  },
  watch: {
    value: function () {
      this.$emit("input", this.value);
    },
  },
};
</script>